const { REACT_APP_VERSION } = process.env;

export const UNITY_REF = {
  loaderUrl: `/Build/LiveFurnishBuild.loader.js?version=${REACT_APP_VERSION}`,
  dataUrl: `/Build/LiveFurnishBuild.data?version=${REACT_APP_VERSION}`,
  frameworkUrl: `/Build/LiveFurnishBuild.framework.js?version=${REACT_APP_VERSION}`,
  codeUrl: `/Build/LiveFurnishBuild.wasm?version=${REACT_APP_VERSION}`,
  streamingAssetsUrl: 'StreamingAssets',
  companyName: 'DefaultCompany',
  productName: 'Live FurnishV2',
  productVersion: '0.1',
};
export const THEME_LIGHT = 'theme-light';
export const THEME_DARK = 'theme-dark';

export const TITLE_PREFIX = 'imagine.io';
export const NETWORK_ERROR = 'Network Error';

export const FOV_MIN_VALUE = 0;
export const FOV_MAX_VALUE = 80;

export const LIGHT_WIDTH_MIN_METERS = 0;
export const LIGHT_WIDTH_MAX_METERS = 20;

export const LIGHT_POINT_SIZE_MIN_METERS = 0;
export const LIGHT_POINT_SIZE_MAX_METERS = 2.54; // previous value: 100

export const CAMERA_HEIGHT_MIN_VALUE = -5.51;
export const CAMERA_HEIGHT_MAX_VALUE = 10.49;
export const CAMERA_HEIGHT_DEFAULT = 2.27;

export const BLUR_INTENSITY_MIN_VALUE = 0;
export const BLUR_INTENSITY_MAX_VALUE = 10;

export const SUBSCRIBED = 'Subscribed';
export const UNSUBSCRIBED = 'Not subscribed';

export const PROJECT_TYPE_ID = '1';

export const LF_DEBUGGER = 'lf_debugger';
export const LF_DEBUGGER_EVENT_TRACKING = 'LF_DEBUGGER_EVENT_TRACKING';

export const LF_DEBUGGER_HUBSPOT = 'LF_DEBUGGER_HUBSPOT';
export const RESTRICTED_EMAILS = [
  'imagine.io',
  'livefurnish.com',
  'taglineinfotech',
  'tagline',
  'algoworks',
  'zedinteractive',
];

// HDRI Light API IDs for retail automation and configurator
export const RETAIL_HDRI_LIGHT_ID_PRODUCTION = 108;
export const RETAIL_HDRI_LIGHT_ID_NON_PRODUCTION = 108;

//ls
export const AUTH_TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
export const MEMBER_ID = 'id';
export const THEME = 'theme';
export const USER_ID = 'user_id';
export const GAMIFIED = 'gamified';
export const GUEST_USER_STARTER = 'guest_user_starter_login';
export const GOOGLE_SIGN_UP = 'google_sign_up';

// Request
export const REQUEST_DATA = 'request_data';
export const REQUEST_IMAGES_TABS = [
  { id: 1, name: 'product', goNextTo: 2 },
  { id: 2, name: 'closeUp', goNextTo: 3, goBackTo: 1 },
  { id: 3, name: 'other', goBackTo: 2 },
];

export const LIGHT_TOAST_OPTIONS = {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  closeButton: false,
};

export const DARK_TOAST_OPTIONS = {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  closeButton: false,
};

export const CURATOR_DB = 'curator';
export const STORAGE_DB = '/idbfs';

export const CONVERT_IN_METER = 39.37;
export const CONVERT_IN_INCHES = 39.37;
export const TABLE_HEADER_SCROLL_THRESHOLD = 50;

export const FILTER_OPTIONS = [
  { label: 'Filter by', value: '' },
  { label: 'ROOM', value: '1' },
  { label: 'LIFESTYLEROOM', value: '2' },
  { label: 'SILOROOM', value: '3' },
  { label: 'VIGNETTEROOM', value: '4' },
  { label: 'THREESIXTYROOM', value: '5' },
  { label: 'VIDEOROOM', value: '6' },
  { label: 'CONFIGURATORROOM', value: '7' },
  { label: 'AUGMENTED_REALITYROOM', value: '8' },
];

export const SORT_BY = [
  { label: 'Sort by' },
  { label: 'Newest first', value: '-created_at' },
  { label: 'Oldest first', value: 'created_at' },
  { label: 'Name:A-Z', value: 'name' },
  { label: 'Name :Z-A', value: '-name' },
];

export const THREEJS_TEXTURE_WIDTH = 2048
export const THREEJS_TEXTURE_HEIGHT = 2048